var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.found
    ? _c("div", { staticClass: "widget-inner mt-5 xcrossSeller" }, [
        _c("div", { staticClass: "headline" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$translate("Servershop5::Template.zubehoerundersatz")
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sub-headline mb-4" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$translate("Servershop5::Template.zubehoerundersatz")
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "hidding",
            staticClass: "hide-more-items",
            attrs: { id: "hidden_crossmore" },
          },
          [
            Object.keys(_vm.alldata).length > 0
              ? [
                  _c(
                    "ul",
                    { staticClass: "product-list row grid categoryItem" },
                    [
                      _vm._l(_vm.alldata, function (group) {
                        return [
                          _vm._l(group, function (item) {
                            return [
                              _c(
                                "li",
                                {
                                  staticClass:
                                    "col-12 col-sm-6 col-md-4 col-lg-3",
                                },
                                [
                                  _c("category-item", {
                                    attrs: {
                                      "item-data": item.data,
                                      "decimal-count": 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              : [_vm._m(0)],
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "showMore btn btn-dark-blue mx-auto d-flex mt-3" },
          [
            _c("span", [
              _vm._v(
                "\n             " +
                  _vm._s(_vm.$translate("Servershop5::Template.zuebhoerMore")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$translate("Servershop5::Template.zubehoerLess")) +
                  "\n        "
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "d-flex justify-content-center h-100 align-items-center" },
      [
        _c(
          "div",
          {
            staticClass: "spinner-border text-primary large-spinner",
            attrs: { role: "status" },
          },
          [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }